<template>
  <main-template>
    <v-row class="mb-4">
      <v-col cols="12">
        <div class="page-head">
          <div class="page-head-icon">
            <v-icon color="white">mdi-chart-box-outline</v-icon>
          </div>
          <div class="page-head-text">
            <h2 class="page-head-title">Relatórios</h2>
            <div class="page-head-subtitle">
              {{ escola.descricao || "Selecione uma unidade escolar" }}
            </div>
          </div>
        </div>
        <div v-if="isSuperAdmin" class="mt-4 school-search">
          <v-autocomplete
            v-model="escola"
            :items="this.franquiasList"
            item-text="descricao"
            item-value="id"
            dense
            return-object
            filled
            hide-details
            background-color="var(--brand-soft-2)"
            prepend-inner-icon="mdi-domain"
            label="Pesquise uma unidade escolar"
          ></v-autocomplete>
        </div>
      </v-col>
    </v-row>
    <v-tabs v-model="tab" grow class="rel-tabs mb-6" color="var(--brand)">
      <v-tab href="#pontofiq" class="rel-tab">
        <v-icon left>mdi-clock-outline</v-icon>
        Relatórios de Ponto
      </v-tab>
      <v-tab v-if="canVerRelatorioPontoDiario" href="#ponto-diario" class="rel-tab">
        <v-icon left>mdi-calendar-clock-outline</v-icon>
        Ponto Diário
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab" class="mt-4">
      <!-- Aba de Turmas -->
      <v-tab-item value="turmas" class="pa-4" style="background-color: var(--app-bg)">
        <v-row style="background-color: var(--app-bg)">
          <v-col cols="12" sm="6" md="4" v-if="escola && escola.id">
            <v-card
              color="secondary"
              @click="listarTurmasEscola(escola.id)"
              :id="`card-turmas-escola-${escola.id}`"
            >
              <v-card-title>
                <v-icon large left>groups</v-icon>
                <span class="title font-weight-light">Turmas (sem alunos)</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola atual</v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="4" v-if="escola && escola.id">
            <v-card
              color="secondary"
              @click="alunosPorUnidades(escola.id)"
              :id="`card-alunos-unidades-${escola.id}`"
            >
              <v-card-title>
                <v-icon large left>groups</v-icon>
                <span class="title font-weight-light">Turmas (com alunos)</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola atual</v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="4">
            <v-card color="secondary" @click="listarTodasTurmas()" :id="`card-todas-turmas`">
              <v-card-title>
                <v-icon large left>groups</v-icon>
                <span class="title font-weight-light">Todas as turmas (sem alunos)</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Todas as escolas</v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="4">
            <v-card
              color="secondary"
              @click="escolasTurmasAlunos()"
              :id="`card-todas-escolas-turmas`"
            >
              <v-card-title>
                <v-icon large left>groups</v-icon>
                <span class="title font-weight-light">Todas as Turmas (com alunos)</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Todas as escolas</v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-tab-item>
      <!-- Aba de Relatórios -->
      <v-tab-item value="relatorios" class="pa-4" style="background-color: var(--app-bg)">
        <v-row style="background-color: var(--app-bg)">
          <v-col cols="12" sm="6" md="4">
            <v-card color="secondary" @click="insercaoAulas()" :id="`card-relatorio-aulas`">
              <v-card-title>
                <v-icon large left>mdi-book-variant</v-icon>
                <span class="title font-weight-light">Relatórios de Aulas</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Inserção de aulas</v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="4" v-if="escola && escola.id">
            <v-card
              color="secondary"
              @click="relatoriosEvasao(escola.id)"
              :id="`card-relatorio-faltas-${escola.id}`"
            >
              <v-card-title>
                <v-icon large left>flag</v-icon>
                <span class="title font-weight-light">Faltas (Alunos) </span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola Atual</v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-tab-item>

      <!-- Aba de Documentos -->
      <v-tab-item value="documentos" class="pa-4" style="background-color: var(--app-bg)">
        <v-row style="background-color: var(--app-bg)">
          <v-col cols="12" sm="6" md="4">
            <v-card
              color="secondary"
              @click="boletinsFranquia(escola.id)"
              :id="`card-boletins-escola-${escola.id}`"
            >
              <v-card-title>
                <v-icon large left>receipt_long</v-icon>
                <span class="title font-weight-light">Boletins</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola atual</v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="4">
            <v-card
              color="secondary"
              @click="relatoriosBnccFranquia(escola.id)"
              :id="`card-relatorios-bncc-escola-${escola.id}`"
            >
              <v-card-title>
                <v-icon large left>child_care</v-icon>
                <span class="title font-weight-light">Relatórios BNCC</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola atual</v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="4" v-if="escola && escola.id">
            <v-card
              color="secondary"
              @click="relatorioDeListagemDosPlanosLancados(escola.id)"
              :id="`card-planos-lancados-escola-${escola.id}`"
            >
              <v-card-title>
                <v-icon large left>auto_stories</v-icon>
                <span class="title font-weight-light">Planos lançados</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola Atual</v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="4" v-if="escola && escola.id">
            <v-card
              color="secondary"
              @click="relatorioDeListagemDosPlanosLancadosGeral(escola.id)"
              :id="`card-planos-lancados-geral`"
            >
              <v-card-title>
                <v-icon large left>auto_stories</v-icon>
                <span class="title font-weight-light">Planos lançados</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Todas as escolas</v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-tab-item>

      <!-- Aba de Gestão -->
      <v-tab-item value="gestao" class="pa-4" style="background-color: var(--app-bg)">
        <v-row style="background-color: var(--app-bg)">
          <v-col cols="12" sm="6" md="4" v-if="escola && escola.id">
            <v-card
              color="secondary"
              @click="lotacaoEscola(escola.id)"
              :id="`card-lotacao-escola-${escola.id}`"
            >
              <v-card-title>
                <v-icon large left>percent</v-icon>
                <span class="title font-weight-light">Lotação</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola Atual</v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="4" class="pa-4">
            <v-card color="secondary" @click="lotacaoGeral()" :id="`card-lotacao-geral`">
              <v-card-title>
                <v-icon large left>percent</v-icon>
                <span class="title font-weight-light">Lotação</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Todas as escolas</v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="4">
            <v-card color="secondary" @click="lotacao()" :id="`card-lotacao-por-escola`">
              <v-card-title>
                <v-icon large left>percent</v-icon>
                <span class="title font-weight-light">Lotação por Escolas</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Todas as escolas</v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="4" v-if="escola && escola.id">
            <v-card
              color="secondary"
              @click="relatoriosCensoFranquia(escola.id)"
              :id="`card-relatorios-censo-escola-${escola.id}`"
            >
              <v-card-title>
                <v-icon large left>mdi-book-variant</v-icon>
                <span class="title font-weight-light">Censo</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola atual</v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="4" v-if="escola && escola.id">
            <v-card
              color="secondary"
              @click="recursosHumanos(escola.id)"
              :id="`card-relatorios-censo-escola-${escola.id}`"
            >
              <v-card-title>
                <v-icon large left>mdi-account-group</v-icon>
                <span class="title font-weight-light"> Recursos Humanos </span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola atual</v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="4" v-if="escola && escola.id">
            <v-card
              color="secondary"
              @click="qtdProfessoresPorDisciplina()"
              :id="`card-professores-por-disciplina`"
            >
              <v-card-title>
                <v-icon large left> group </v-icon>
                <span class="title font-weight-light">Prof. por Componente Curricular</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Todas as escolas</v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="4" v-if="escola && escola.id">
            <v-card
              color="secondary"
              @click="alunosNaoMatriculados(escola.id)"
              :id="`card-alunos-nao-matriculados-${escola.id}`"
            >
              <v-card-title>
                <v-icon large left>edit_off</v-icon>
                <span class="title font-weight-light">Alunos não matriculados</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola Atual</v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="4">
            <v-card
              color="secondary"
              @click="alunosNaoMatriculadosGeral()"
              :id="`card-alunos-nao-matriculados-geral`"
            >
              <v-card-title>
                <v-icon large left>edit_off</v-icon>
                <span class="title font-weight-light">Alunos não matriculados</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Todas as escolas</v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="4" v-if="escola && escola.id">
            <v-card
              color="secondary"
              @click="resumoMovimentoEscolar(escola.id)"
              :id="`card-movimento-escolar-${escola.id}`"
            >
              <v-card-title>
                <v-icon large left>query_stats</v-icon>
                <span class="title font-weight-light">Resumo movimento escolar</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola atual</v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="4" v-if="escola && escola.id">
            <v-card
              color="secondary"
              @click="resumoMovimentoEscolarGeral()"
              :id="`card-movimento-escolar-${escola.id}`"
            >
              <v-card-title>
                <v-icon large left>query_stats</v-icon>
                <span class="title font-weight-light">Resumo movimento escolar</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Todas as escolas</v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-card color="secondary" @click="relatorioAlunosEspeciais()">
              <v-card-title>
                <v-icon large left>accessible</v-icon>
                <span class="title font-weight-light"
                  >Relatório de alunos com necessidades especiais</span
                >
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Todas as escolas</v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-tab-item>
      <v-tab-item value="notifiq" class="pa-4" style="background-color: var(--app-bg)">
        <v-row style="background-color: var(--app-bg)">
          <v-col cols="12" sm="6" md="4" v-if="escola && escola.id">
            <v-card color="primary" @click="notifiqAlunosPorTurma(escola.id)">
              <v-card-title>
                <v-icon large left>mdi-account-group</v-icon>
                <span class="title font-weight-light">Alunos por Turma</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Notifiq - Escola atual</v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="4" v-if="escola && escola.id">
            <v-card color="primary" @click="notifiqAcessosEscola(escola.id)">
              <v-card-title>
                <v-icon large left>mdi-card-account-details-outline</v-icon>
                <span class="title font-weight-light">Acessos dos Pais</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Notifiq - Escola atual</v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="4" v-if="escola && escola.id">
            <v-card color="primary" @click="abrirModalPresencasNotifiq('escola')">
              <v-card-title>
                <v-icon large left>mdi-fingerprint</v-icon>
                <span class="title font-weight-light">Presenças</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Notifiq - Escola atual</v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="4">
            <v-card color="primary" @click="abrirModalPresencasNotifiq('geral')">
              <v-card-title>
                <v-icon large left>mdi-domain</v-icon>
                <span class="title font-weight-light">Presenças</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold"
                >Notifiq - Todas as escolas</v-card-text
              >
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="4" v-if="escola && escola.id">
            <v-card color="yellowTheme" @click="abrirDialogFaltantesNotifiq">
              <v-card-title>
                <v-icon large left>mdi-account-alert-outline</v-icon>
                <span class="title font-weight-light">Alunos sem Presença</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Notifiq - Escola atual</v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-tab-item>

      <v-tab-item value="pontofiq" class="pa-2">
        <div class="rel-intro mb-4">Selecione um relatório para gerar em PDF</div>
        <v-row>
          <v-col cols="12" sm="6" md="4" lg="3" class="report-col r1">
            <div
              class="report-card"
              id="card-relatorio-justificativas"
              @click="abrirModalRelatorioJustificativas"
            >
              <div class="report-card-top">
                <div class="report-card-icon tone-purple">
                  <v-icon small color="white">mdi-file-document-check-outline</v-icon>
                </div>
                <div class="report-card-arrow">
                  <v-icon small>mdi-arrow-right</v-icon>
                </div>
              </div>
              <div class="report-card-title">Justificativas e Atestados</div>
              <div class="report-card-subtitle">Atestados de Colaboradores</div>
            </div>
          </v-col>

          <v-col cols="12" sm="6" md="4" lg="3" class="report-col r2">
            <div class="report-card" id="card-relatorio-faltas" @click="abrirModalRelatorioFaltas">
              <div class="report-card-top">
                <div class="report-card-icon tone-rose">
                  <v-icon small color="white">mdi-account-alert-outline</v-icon>
                </div>
                <div class="report-card-arrow">
                  <v-icon small>mdi-arrow-right</v-icon>
                </div>
              </div>
              <div class="report-card-title">Faltas no Período</div>
              <div class="report-card-subtitle">Faltas de Colaboradores</div>
            </div>
          </v-col>

          <v-col cols="12" sm="6" md="4" lg="3" class="report-col r3">
            <div
              class="report-card"
              id="card-relatorio-espelho-ponto"
              @click="abrirModalRelatorioEspelhoPonto"
            >
              <div class="report-card-top">
                <div class="report-card-icon tone-blue">
                  <v-icon small color="white">mdi-calendar-clock</v-icon>
                </div>
                <div class="report-card-arrow">
                  <v-icon small>mdi-arrow-right</v-icon>
                </div>
              </div>
              <div class="report-card-title">Espelho de Ponto</div>
              <div class="report-card-subtitle">Espelho de Ponto de Colaboradores</div>
            </div>
          </v-col>

          <v-col cols="12" sm="6" md="4" lg="3" class="report-col r4">
            <div
              class="report-card"
              id="card-relatorio-atrasos"
              @click="abrirModalRelatorioAtrasos"
            >
              <div class="report-card-top">
                <div class="report-card-icon tone-amber">
                  <v-icon small color="white">mdi-clock-alert-outline</v-icon>
                </div>
                <div class="report-card-arrow">
                  <v-icon small>mdi-arrow-right</v-icon>
                </div>
              </div>
              <div class="report-card-title">Atrasos no Período</div>
              <div class="report-card-subtitle">Atrasos de Colaboradores</div>
            </div>
          </v-col>
        </v-row>
      </v-tab-item>

      <v-tab-item v-if="canVerRelatorioPontoDiario" value="ponto-diario" class="pa-2">
        <div class="rel-intro mb-4">
          Escolha o dia e veja entradas e saídas de todos os colaboradores de uma vez
        </div>
        <v-row>
          <v-col cols="12" sm="6" md="4" lg="3" class="report-col">
            <div
              class="report-card"
              id="card-relatorio-ponto-diario"
              @click="$router.push({ name: 'relatorios.pontoDiario' })"
            >
              <div class="report-card-top">
                <div class="report-card-icon tone-green">
                  <v-icon small color="white">mdi-calendar-check-outline</v-icon>
                </div>
                <div class="report-card-arrow">
                  <v-icon small>mdi-arrow-right</v-icon>
                </div>
              </div>
              <div class="report-card-title">Relatório de Ponto Diário</div>
              <div class="report-card-subtitle">Entradas e Saídas de um Dia</div>
            </div>
          </v-col>
        </v-row>
      </v-tab-item>
    </v-tabs-items>

    <v-dialog v-model="dialogFaltantesNotifiq" max-width="450">
      <v-card>
        <v-card-title class="text-h5">Alunos sem Presença - Notifiq</v-card-title>

        <v-card-text>
          <v-row justify="center" class="mt-4">
            <v-date-picker v-model="dataFaltantesNotifiq" locale="pt-br"></v-date-picker>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="dialogFaltantesNotifiq = false">Cancelar</v-btn>
          <v-btn color="green darken-1" text @click="gerarFaltantesNotifiq">Gerar Relatório</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogPresencasNotifiq" max-width="500">
      <v-card>
        <v-card-title class="text-h5">
          Presenças - Notifiq
          <v-chip class="ml-2" small color="blue lighten-4">
            {{ tipoPresencasNotifiq === "geral" ? "Todas as escolas" : "Escola atual" }}
          </v-chip>
        </v-card-title>

        <v-card-text>
          <v-row justify="center" class="mt-4">
            <v-date-picker
              v-model="periodoPresencasNotifiq"
              range
              locale="pt-br"
              color="primary"
            ></v-date-picker>
          </v-row>
          <v-row class="mt-2 px-2">
            <v-col cols="6">
              <v-text-field
                :value="periodoPresencasNotifiq[0] || ''"
                label="Data início"
                prepend-icon="mdi-calendar-start"
                readonly
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                :value="periodoPresencasNotifiq[1] || ''"
                label="Data fim"
                prepend-icon="mdi-calendar-end"
                readonly
                dense
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="dialogPresencasNotifiq = false">Cancelar</v-btn>
          <v-btn
            color="green darken-1"
            text
            :disabled="periodoPresencasNotifiq.length === 0"
            @click="gerarPresencasNotifiq"
          >
            Gerar Relatório
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <e-modal-boletim-franquia
      :dialog="dialogBoletimFranquia"
      :franquia_id="franquia_id"
      @dialogChange="dialogBoletimFranquia = $event"
    ></e-modal-boletim-franquia>
    <e-modal-falta-aluno-franquia
      :dialog="dialogFaltaAlunoFranquia"
      :franquia_id="franquia_id"
      @dialogChange="dialogFaltaAlunoFranquia = $event"
    ></e-modal-falta-aluno-franquia>

    <v-dialog v-model="dialogRelatorioJustificativas" max-width="500">
      <v-card>
        <v-card-title class="text-h5"> Relatório de Justificativas / Atestados </v-card-title>

        <v-card-text class="pt-4">
          <v-autocomplete
            v-if="isAdmin"
            v-model="filtroRelatorio.colaboradorId"
            :items="colaboradores"
            item-text="name"
            item-value="id"
            label="Selecionar Colaborador"
            outlined
            dense
            required
          />
          <v-text-field
            v-else
            :value="user.name"
            label="Colaborador"
            outlined
            dense
            readonly
            disabled
          />

          <div class="text-subtitle-2 mb-1">Período (Opcional)</div>
          <v-row justify="center">
            <v-date-picker
              v-model="filtroRelatorio.periodo"
              range
              locale="pt-br"
              color="primary"
            ></v-date-picker>
          </v-row>
          <v-row class="mt-2 px-2">
            <v-col cols="6">
              <v-text-field
                :value="filtroRelatorio.periodo[0] || ''"
                label="Data início"
                prepend-icon="mdi-calendar-start"
                readonly
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                :value="filtroRelatorio.periodo[1] || ''"
                label="Data fim"
                prepend-icon="mdi-calendar-end"
                readonly
                dense
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="pb-4 px-6">
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="dialogRelatorioJustificativas = false">Cancelar</v-btn>
          <v-btn
            color="green darken-1"
            text
            :disabled="!filtroRelatorio.colaboradorId"
            @click="gerarRelatorioJustificativas"
          >
            Gerar Relatório
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal Relatório de Faltas -->
    <v-dialog v-model="dialogRelatorioFaltas" max-width="500">
      <v-card>
        <v-card-title class="text-h5"> Relatório de Faltas no Período </v-card-title>

        <v-card-text class="pt-4">
          <v-autocomplete
            v-if="isAdmin"
            v-model="filtroRelatorio.colaboradorId"
            :items="colaboradores"
            item-text="name"
            item-value="id"
            label="Selecionar Colaborador"
            outlined
            dense
            required
          />
          <v-text-field
            v-else
            :value="user.name"
            label="Colaborador"
            outlined
            dense
            readonly
            disabled
          />

          <div class="text-subtitle-2 mb-1">Período (Obrigatório)</div>
          <v-row justify="center">
            <v-date-picker
              v-model="filtroRelatorio.periodo"
              range
              locale="pt-br"
              color="primary"
            ></v-date-picker>
          </v-row>
          <v-row class="mt-2 px-2">
            <v-col cols="6">
              <v-text-field
                :value="filtroRelatorio.periodo[0] || ''"
                label="Data início"
                prepend-icon="mdi-calendar-start"
                readonly
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                :value="filtroRelatorio.periodo[1] || ''"
                label="Data fim"
                prepend-icon="mdi-calendar-end"
                readonly
                dense
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="pb-4 px-6">
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="dialogRelatorioFaltas = false">Cancelar</v-btn>
          <v-btn
            color="green darken-1"
            text
            :disabled="!filtroRelatorio.colaboradorId || filtroRelatorio.periodo.length === 0"
            @click="gerarRelatorioFaltas"
          >
            Gerar Relatório
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal Relatório Espelho de Ponto Multiplos -->
    <v-dialog v-model="dialogRelatorioEspelhoPonto" max-width="500">
      <v-card>
        <v-card-title class="text-h5"> Espelho de Ponto por Período </v-card-title>
        <v-card-text class="pt-4">
          <v-autocomplete
            v-if="isAdmin"
            v-model="filtroRelatorio.colaboradoresIds"
            :items="colaboradores"
            item-text="name"
            item-value="id"
            label="Selecionar Colaborador(es)"
            outlined
            dense
            multiple
            chips
            deletable-chips
            required
          >
            <template v-slot:prepend-item>
              <v-list-item ripple @mousedown.prevent @click="toggleSelectAllColaboradores">
                <v-list-item-action>
                  <v-icon
                    :color="
                      (filtroRelatorio.colaboradoresIds || []).length === colaboradores.length
                        ? 'indigo'
                        : ''
                    "
                  >
                    {{ iconSelectAllColaboradores }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title> Selecionar Todos </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2"></v-divider>
            </template>
          </v-autocomplete>
          <v-text-field
            v-else
            :value="user.name"
            label="Colaborador"
            outlined
            dense
            readonly
            disabled
          />

          <div class="text-subtitle-2 mb-1">Período (Obrigatório)</div>
          <v-row justify="center">
            <v-date-picker
              v-model="filtroRelatorio.periodo"
              range
              locale="pt-br"
              color="primary"
            ></v-date-picker>
          </v-row>
          <v-row class="mt-2 px-2">
            <v-col cols="6">
              <v-text-field
                :value="filtroRelatorio.periodo[0] || ''"
                label="Data início"
                prepend-icon="mdi-calendar-start"
                readonly
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                :value="filtroRelatorio.periodo[1] || ''"
                label="Data fim"
                prepend-icon="mdi-calendar-end"
                readonly
                dense
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="pb-4 px-6">
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="dialogRelatorioEspelhoPonto = false">Cancelar</v-btn>
          <v-btn
            color="green darken-1"
            text
            :disabled="
              (isAdmin && (filtroRelatorio.colaboradoresIds || []).length === 0) ||
              (!isAdmin && !user) ||
              filtroRelatorio.periodo.length === 0
            "
            @click="gerarRelatorioEspelhoPonto"
          >
            Gerar Relatório
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal Relatório de Atrasos -->
    <v-dialog v-model="dialogRelatorioAtrasos" max-width="500">
      <v-card>
        <v-card-title class="text-h5"> Relatório de Atrasos no Período </v-card-title>

        <v-card-text class="pt-4">
          <v-autocomplete
            v-if="isAdmin"
            v-model="filtroRelatorioAtrasos.colaboradoresIds"
            :items="colaboradores"
            item-text="name"
            item-value="id"
            label="Selecionar Colaborador(es)"
            outlined
            dense
            multiple
            chips
            deletable-chips
          >
            <template v-slot:prepend-item>
              <v-list-item ripple @mousedown.prevent @click="toggleSelectAllColaboradoresAtrasos">
                <v-list-item-action>
                  <v-icon
                    :color="
                      (filtroRelatorioAtrasos.colaboradoresIds || []).length ===
                      colaboradores.length
                        ? 'indigo'
                        : ''
                    "
                  >
                    {{ iconSelectAllColaboradoresAtrasos }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title> Selecionar Todos </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2"></v-divider>
            </template>
          </v-autocomplete>
          <v-text-field
            v-else
            :value="user.name"
            label="Colaborador"
            outlined
            dense
            readonly
            disabled
          />

          <div class="text-subtitle-2 mb-1">Período (Obrigatório)</div>
          <v-row justify="center">
            <v-date-picker
              v-model="filtroRelatorioAtrasos.periodo"
              range
              locale="pt-br"
              color="primary"
            ></v-date-picker>
          </v-row>
          <v-row class="mt-2 px-2">
            <v-col cols="6">
              <v-text-field
                :value="filtroRelatorioAtrasos.periodo[0] || ''"
                label="Data início"
                prepend-icon="mdi-calendar-start"
                readonly
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                :value="filtroRelatorioAtrasos.periodo[1] || ''"
                label="Data fim"
                prepend-icon="mdi-calendar-end"
                readonly
                dense
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="pb-4 px-6">
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="dialogRelatorioAtrasos = false">Cancelar</v-btn>
          <v-btn
            color="green darken-1"
            text
            :disabled="filtroRelatorioAtrasos.periodo.length === 0"
            @click="gerarRelatorioAtrasos"
          >
            Gerar Relatório
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </main-template>
</template>

<script>
import { hojeBrasilia } from "@/utils/dataBrasilia";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Relatórios",
  data() {
    return {
      tab: null,
      escola: {
        descricao: null,
        id: null,
      },
      dialogBoletimFranquia: false,
      franquia_id: null,
      dialogFaltaAlunoFranquia: false,
      dialogFaltantesNotifiq: false,
      dataFaltantesNotifiq: hojeBrasilia(),
      dialogPresencasNotifiq: false,
      tipoPresencasNotifiq: "escola",
      periodoPresencasNotifiq: [],
      colaboradores: [],
      dialogRelatorioJustificativas: false,
      dialogRelatorioFaltas: false,
      dialogRelatorioEspelhoPonto: false,
      dialogRelatorioAtrasos: false,
      filtroRelatorio: {
        colaboradorId: null,
        colaboradoresIds: [],
        periodo: [],
      },
      filtroRelatorioAtrasos: {
        colaboradorId: null,
        colaboradoresIds: [],
        periodo: [],
      },
    };
  },
  computed: {
    ...mapGetters("Auth", ["user"]),
    ...mapGetters("Franquias", ["franquiasList", "carregandoFranquias"]),
    isAdmin() {
      return (
        this.user?.roles?.filter((role) =>
          ["super-admin", "admin", "TI", "lider"].includes(role.name)
        ).length >= 1
      );
    },
    isSuperAdmin() {
      return this.user?.roles?.filter((role) => role.name === "super-admin").length >= 1;
    },
    canVerRelatorioPontoDiario() {
      if (this.user?.roleName === "super-admin") return true;
      return this.$can(["colaboradores.pontos"]);
    },
    iconSelectAllColaboradores() {
      const colaboradoresIds = this.filtroRelatorio.colaboradoresIds || [];
      if (colaboradoresIds.length === this.colaboradores.length) return "mdi-close-box";
      if (colaboradoresIds.length > 0) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    iconSelectAllColaboradoresAtrasos() {
      const colaboradoresIds = this.filtroRelatorioAtrasos.colaboradoresIds || [];
      if (colaboradoresIds.length === this.colaboradores.length) return "mdi-close-box";
      if (colaboradoresIds.length > 0) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },
  methods: {
    ...mapActions("Franquias", ["loadFranquias"]),
    async alunosPorUnidades(franquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.alunosPorUnidadeEScolar(parseInt(franquia_id, 10));
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },

    async lotacaoGeral() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.lotacaoGeral();
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },

    async lotacao() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.lotacao();
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },

    async lotacaoEscola(franquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.lotacaoEscola(parseInt(franquia_id, 10));
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },

    async boletinsFranquia(franquia_id) {
      try {
        this.franquia_id = franquia_id;
        this.dialogBoletimFranquia = !this.dialogBoletimFranquia;
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },

    async relatoriosBnccFranquia(franquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.relatoriosBnccFranquia(parseInt(franquia_id, 10));
      } catch (error) {
        this.$toast.danger("Não encontramos turmas de infantil vinculado a essa escola!");
        // this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },

    async inscritosCongresso() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.inscritosCongresso();
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },

    async escolasTurmasAlunos() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.escolasTurmasAlunos();
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },

    async listarTodasTurmas() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.listarTodasTurmas();
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },

    async listarTurmasEscola(franquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.listarTurmasFranquia(parseInt(franquia_id, 10));
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },

    async insercaoAulas() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.insercaoAulas();
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },

    async resumoMovimentoEscolar(fraquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.resumoMovimentoEscolar(fraquia_id);
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },

    async resumoMovimentoEscolarGeral() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.resumoMovimentoEscolarGeral();
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },

    async relatorioDeListagemDosPlanosLancados(franquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.relatorioDeListagemDosPlanosLancados(
          parseInt(franquia_id, 10)
        );
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },

    async relatorioDeListagemDosPlanosLancadosGeral() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.relatorioDeListagemDosPlanosLancadosGeral();
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    async relatoriosEvasao(franquia_id) {
      try {
        this.franquia_id = franquia_id;
        this.dialogFaltaAlunoFranquia = !this.dialogFaltaAlunoFranquia;
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    async alunosNaoMatriculados(franquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.alunosNaoMatriculados(parseInt(franquia_id, 10));
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    async alunosNaoMatriculadosGeral() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.alunosNaoMatriculadosGeral();
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    async qtdProfessoresPorDisciplina() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.qtdProfessoresPorDisciplina();
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    async relatoriosCensoFranquia(franquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.relatoriosCensoFranquia(parseInt(franquia_id, 10));
      } catch (error) {
        this.$toast.danger("Não foi possível carregar a informação solicitada! Tente novamente!");
      } finally {
        this.$loaderService.close();
      }
    },
    async recursosHumanos(franquia_id) {
      try {
        this.$loaderService.open("Gerando relatório de recursos humanos...");

        await this.$services.relatoriosService.recursosHumanos(franquia_id);
        this.$toast.success("Relatório gerado com sucesso!");
      } catch (error) {
        this.$toast.danger("Nenhum funcionário encontrado para esta franquia!");
        if (error.response && error.response.data && error.response.data.message) {
          this.$handleError(error.response.data);
        } else {
          this.$handleError(error);
        }
      } finally {
        this.$loaderService.close();
      }
    },

    async relatorioAlunosEspeciais() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.relatorioAlunosEspeciais();
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    async notifiqAlunosPorTurma(franquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.notifiqAlunosPorTurma(parseInt(franquia_id, 10));
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async notifiqAcessosEscola(franquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.notifiqAcessosEscola(parseInt(franquia_id, 10));
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    abrirDialogFaltantesNotifiq() {
      this.dataFaltantesNotifiq = hojeBrasilia();
      this.dialogFaltantesNotifiq = true;
    },
    async gerarFaltantesNotifiq() {
      this.dialogFaltantesNotifiq = false;
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.faltantesNotifiq(
          parseInt(this.escola.id, 10),
          this.dataFaltantesNotifiq
        );
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    abrirModalPresencasNotifiq(tipo) {
      this.tipoPresencasNotifiq = tipo;
      const hoje = hojeBrasilia();
      this.periodoPresencasNotifiq = [hoje, hoje];
      this.dialogPresencasNotifiq = true;
    },
    async gerarPresencasNotifiq() {
      this.dialogPresencasNotifiq = false;
      try {
        this.$loaderService.open("Carregando dados...");
        const [dataInicio, dataFim = dataInicio] = [...this.periodoPresencasNotifiq].sort();
        if (this.tipoPresencasNotifiq === "geral") {
          await this.$services.relatoriosService.presencasNotifiqGeral(dataInicio, dataFim);
        } else {
          await this.$services.relatoriosService.presencasNotifiq(
            parseInt(this.escola.id, 10),
            dataInicio,
            dataFim
          );
        }
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async carregarColaboradores() {
      try {
        this.colaboradores = await this.$services.colaboradorPontosService.listarColaboradores();
      } catch (error) {
        /* eslint-disable-next-line no-console */
        console.error("Erro ao carregar colaboradores:", error);
      }
    },
    abrirModalRelatorioJustificativas() {
      this.filtroRelatorio = {
        colaboradorId: this.isAdmin ? null : this.user.id,
        colaboradoresIds: [],
        periodo: [],
      };
      this.dialogRelatorioJustificativas = true;
    },
    abrirModalRelatorioFaltas() {
      const hoje = hojeBrasilia();
      this.filtroRelatorio = {
        colaboradorId: this.isAdmin ? null : this.user.id,
        colaboradoresIds: [],
        periodo: [hoje, hoje],
      };
      this.dialogRelatorioFaltas = true;
    },
    abrirModalRelatorioEspelhoPonto() {
      const hoje = hojeBrasilia();
      this.filtroRelatorio = {
        colaboradorId: null,
        colaboradoresIds: this.isAdmin ? [] : [this.user.id],
        periodo: [hoje, hoje],
      };
      this.dialogRelatorioEspelhoPonto = true;
    },
    toggleSelectAllColaboradores() {
      const colaboradoresIds = this.filtroRelatorio.colaboradoresIds || [];
      if (colaboradoresIds.length === this.colaboradores.length) {
        this.filtroRelatorio.colaboradoresIds = [];
      } else {
        this.filtroRelatorio.colaboradoresIds = this.colaboradores.map((c) => c.id);
      }
    },
    async gerarRelatorioEspelhoPonto() {
      this.dialogRelatorioEspelhoPonto = false;
      try {
        this.$loaderService.open("Gerando relatório...");
        const sortedPeriod = [...this.filtroRelatorio.periodo].sort();
        const dataInicio = sortedPeriod[0];
        const dataFim = sortedPeriod[1] || dataInicio;

        if (this.isAdmin) {
          await this.$services.relatoriosService.relatorioEspelhoPontoMultiplosPdf(
            this.filtroRelatorio.colaboradoresIds,
            dataInicio,
            dataFim
          );
        } else {
          const pdfUrl = await this.$services.colaboradorPontosService.meusPontosPeriodoPdf({
            data_inicio: dataInicio,
            data_fim: dataFim,
          });
          const link = document.createElement("a");
          link.href = pdfUrl;
          link.download = `espelho_ponto_${this.user.name}.pdf`;
          link.click();
          window.URL.revokeObjectURL(pdfUrl);
        }
        this.$toast.success("Relatório gerado com sucesso!");
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    async gerarRelatorioJustificativas() {
      this.dialogRelatorioJustificativas = false;
      try {
        this.$loaderService.open("Gerando relatório...");
        const sortedPeriod = [...this.filtroRelatorio.periodo].sort();
        const dataInicio = sortedPeriod[0] || null;
        const dataFim = sortedPeriod[1] || dataInicio;
        await this.$services.relatoriosService.relatorioJustificativasPdf(
          this.filtroRelatorio.colaboradorId,
          dataInicio,
          dataFim
        );
        this.$toast.success("Relatório gerado com sucesso!");
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    async gerarRelatorioFaltas() {
      this.dialogRelatorioFaltas = false;
      try {
        this.$loaderService.open("Gerando relatório...");
        const sortedPeriod = [...this.filtroRelatorio.periodo].sort();
        const dataInicio = sortedPeriod[0];
        const dataFim = sortedPeriod[1] || dataInicio;
        await this.$services.relatoriosService.relatorioFaltasPdf(
          this.filtroRelatorio.colaboradorId,
          dataInicio,
          dataFim
        );
        this.$toast.success("Relatório gerado com sucesso!");
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    abrirModalRelatorioAtrasos() {
      const hoje = hojeBrasilia();
      this.filtroRelatorioAtrasos = {
        colaboradorId: null,
        colaboradoresIds: this.isAdmin ? [] : [this.user.id],
        periodo: [hoje, hoje],
      };
      this.dialogRelatorioAtrasos = true;
    },
    toggleSelectAllColaboradoresAtrasos() {
      const colaboradoresIds = this.filtroRelatorioAtrasos.colaboradoresIds || [];
      if (colaboradoresIds.length === this.colaboradores.length) {
        this.filtroRelatorioAtrasos.colaboradoresIds = [];
      } else {
        this.filtroRelatorioAtrasos.colaboradoresIds = this.colaboradores.map((c) => c.id);
      }
    },
    async gerarRelatorioAtrasos() {
      this.dialogRelatorioAtrasos = false;
      try {
        this.$loaderService.open("Gerando relatório...");
        const sortedPeriod = [...this.filtroRelatorioAtrasos.periodo].sort();
        const dataInicio = sortedPeriod[0];
        const dataFim = sortedPeriod[1] || dataInicio;

        const colaboradoresIds = this.isAdmin ? this.filtroRelatorioAtrasos.colaboradoresIds : [];
        const colaboradorId = !this.isAdmin ? this.user.id : null;

        await this.$services.relatoriosService.relatorioAtrasosPdf(
          colaboradoresIds,
          dataInicio,
          dataFim,
          colaboradorId
        );
        this.$toast.success("Relatório de atrasos gerado com sucesso!");
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
  },
  mounted() {
    this.$loaderService.open("Carregando dados...");
    this.escola = this.user.franquia;
    this.$loaderService.close();
    this.loadFranquias();
    this.carregarColaboradores();
  },
};
</script>
<style scoped>
/* ===== TOPO DA PÁGINA ===== */
.page-head {
  display: flex;
  align-items: center;
  gap: 14px;
}

.page-head-icon {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: linear-gradient(135deg, #4f008f, #7c3aed);
  box-shadow: 0 8px 18px rgba(79, 0, 143, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.page-head-title {
  font-size: 22px;
  font-weight: 800;
  color: var(--text);
  line-height: 1.2;
  margin: 0;
}

.page-head-subtitle {
  font-size: 13.5px;
  color: var(--text-muted);
  font-weight: 500;
}

.school-search {
  max-width: 460px;
}

/* ===== TABS ===== */
.rel-tabs {
  background: var(--surface);
  border-radius: 14px;
  border: 1px solid var(--border);
  box-shadow: 0 2px 12px rgba(15, 23, 42, 0.05);
}

.rel-tabs .v-tab {
  font-weight: 600;
  letter-spacing: 0.3px;
  font-size: 14px;
  color: var(--text-muted);
  transition: color 0.2s ease;
}

.rel-tabs .v-tab--active {
  color: var(--brand) !important;
}

.rel-tabs .v-tab--active .v-icon {
  color: var(--brand-3);
}

.rel-tabs .v-slider--primary {
  background-image: linear-gradient(90deg, #4f008f, #7c3aed) !important;
  height: 3px !important;
  border-radius: 3px;
}

/* ===== PAINEL ===== */
.rel-intro {
  font-size: 13px;
  color: var(--text-muted);
  font-weight: 500;
}

/* ===== CARDS DE RELATÓRIO ===== */
.report-col {
  padding-top: 8px;
  padding-bottom: 16px;
}

.report-card {
  position: relative;
  height: 100%;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 16px;
  padding: 18px;
  cursor: pointer;
  overflow: hidden;
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);
}

.report-card::before {
  content: "";
  position: absolute;
  top: -60px;
  right: -50px;
  width: 160px;
  height: 130px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(124, 58, 237, 0.08), transparent 70%);
  pointer-events: none;
}

.report-card:hover {
  transform: translateY(-3px);
  border-color: rgba(124, 58, 237, 0.35);
  box-shadow: 0 14px 30px rgba(79, 0, 143, 0.12);
}

.report-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
}

.report-card-icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 14px rgba(15, 23, 42, 0.12);
}

.report-card-icon.tone-purple {
  background: linear-gradient(135deg, #7c3aed, #a78bfa);
}

.report-card-icon.tone-rose {
  background: linear-gradient(135deg, #e11d48, #fb7185);
}

.report-card-icon.tone-blue {
  background: linear-gradient(135deg, #0284c7, #38bdf8);
}

.report-card-icon.tone-amber {
  background: linear-gradient(135deg, #d97706, #fbbf24);
}

.report-card-icon.tone-green {
  background: linear-gradient(135deg, #16a34a, #4ade80);
}

.report-card-arrow {
  width: 28px;
  height: 28px;
  border-radius: 9px;
  background: var(--brand-soft-2);
  color: var(--brand-3);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.18s ease, background-color 0.18s ease;
}

.report-card:hover .report-card-arrow {
  transform: translateX(3px);
  background: var(--brand-border);
}

.report-card-title {
  font-size: 15px;
  font-weight: 800;
  color: var(--text);
  margin-bottom: 4px;
  line-height: 1.3;
}

.report-card-subtitle {
  font-size: 12.5px;
  color: var(--text-faint);
  font-weight: 500;
}

/* ===== ANIMAÇÃO DE ENTRADA ===== */
.report-col {
  animation: reportFadeUp 0.45s ease both;
}

.report-col.r2 {
  animation-delay: 0.06s;
}

.report-col.r3 {
  animation-delay: 0.12s;
}

.report-col.r4 {
  animation-delay: 0.18s;
}

@keyframes reportFadeUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (prefers-reduced-motion: reduce) {
  .report-col {
    animation: none;
  }
}
</style>
